export default __webpack_public_path__ + "static/media/ready.4a740587.svg";